import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function NewQuestion() {
  const server_url = process.env.REACT_APP_API_URI;
  const navigate = useNavigate();
  const location = useLocation();

  // Get catId from router state
  const catIdFromProps = location?.state?.catId || '';
  const catName = location?.state?.catName || '';

  const [question, setQuestion] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [category, setCategory] = useState(catIdFromProps);
  const [categoryName, setCategoryName] = useState(catName);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!question.trim())
      return setMessage({ type: 'error', text: 'Question title is required!' });

    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      const newQuestionData = {
        catId: category,
        question,
        searchKey,
        description,
      };

      const response = await axios.post(
        `${server_url}/question/addQuestion`,
        JSON.stringify(newQuestionData),
        { headers: { 'Content-Type': 'application/json' } },
      );

      if (response?.status === 200) {
        setCategory('');
        setCategoryName('');
        setQuestion('');
        setSearchKey('');
        setDescription('');
        setMessage({
          type: 'success',
          text: 'New question added successfully!',
        });

        setTimeout(() => {
          navigate('/admin/questions');
        }, 2000);
      }
    } catch (err) {
      console.error('Error adding question:', err);
      setMessage({
        type: 'error',
        text: 'Failed to add question. Please try again.',
      });
    } finally {
      setTimeout(() => setIsSubmitting(false), 2000);
    }
  };

  return (
    <div className="p-4 max-w-3xl mx-auto bg-white shadow-md rounded-lg">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-semibold text-gray-800">
          Add New Question
        </h1>
        <button
          onClick={() => navigate('/admin/questions')}
          className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition duration-200"
        >
          Back
        </button>
      </div>

      {message.text && (
        <div
          className={`mb-4 text-sm font-medium px-4 py-2 rounded ${
            message.type === 'success'
              ? 'bg-green-100 text-green-700'
              : 'bg-red-100 text-red-700'
          }`}
        >
          {message.text}
        </div>
      )}

      <form className="space-y-4" onSubmit={handleFormSubmit}>
        <div>
          <label className="block text-sm font-semibold mb-1">
            Category Name:
          </label>
          <input
            type="text"
            className="border border-gray-300 rounded-md p-2 w-full bg-gray-100 cursor-not-allowed"
            value={categoryName}
            readOnly
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">
            Question Title:
          </label>
          <input
            type="text"
            className="border border-gray-300 rounded-md p-2 w-full"
            placeholder="Enter question title"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">
            Search Key:
          </label>
          <input
            type="text"
            className="border border-gray-300 rounded-md p-2 w-full"
            placeholder="Enter Search Key"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">
            Question Description:
          </label>
          <textarea
            className="border border-gray-300 rounded-md p-2 w-full h-24"
            placeholder="Enter question description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>

        <button
          type="submit"
          className={`w-full text-white py-2 rounded-md transition duration-200 ${
            isSubmitting
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-500 hover:bg-blue-600'
          }`}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Add Question'}
        </button>
      </form>
    </div>
  );
}
